import { getAutoRefreshTime } from "@/models/time-control/timeUtils";
import { GuiTimeZone } from "@mm/metx-workbench.meteomatics.com";
import { DateTime } from "luxon";
import type { AutoRefreshCtx } from "./timeStateCtxTypes";

/**
 * Debounced persistence settings for TimeState updates.
 * `TIME_STATE_PERSIST_DEBOUNCE_MS` is the quiet window before a save.
 * `TIME_STATE_PERSIST_MAXWAIT_MS` guarantees a save at least every X ms even under
 * continuous, rapid updates (e.g. while an animation is running), preventing the
 * trailing debounced call from being perpetually postponed.
 */
export const TIME_STATE_PERSIST_DEBOUNCE_MS = 800;

/**
 * The current version of the state machine schema which this version of code expects.
 * It gets persisted to DB upon update API call
 * and provides us to have an identifier to accomodate future changes and migration.
 *
 * Be careful to change this attribute, as we currently throw away the persisted state in DB
 * if the version in the frontend code doesn't match with the one on API response.
 */
export const timeStateSchemaVer = "1.1";
export const DEFAULT_REFRESH_RATE = 15;
export const DEFAULT_IS_LOCKED = false;

export const defaultTimeStateVal: string = "AUTO_REFRESH";
export const defaultTimeCtx: AutoRefreshCtx = {
  displayTime: getAutoRefreshTime(DateTime.utc(), DEFAULT_REFRESH_RATE),
  // nextDisplayTime_: "the time that UI is about to load",
  // on TimePoint it is not clear what the nextDisplayTime is, then it is set to the same as DisplayTime
  nextDisplayTime_: getAutoRefreshTime(DateTime.utc(), DEFAULT_REFRESH_RATE),
  timezone: GuiTimeZone.utc,
  modeOpts: { isLocked: DEFAULT_IS_LOCKED, refreshRate: 0 },
};
